// extracted by mini-css-extract-plugin
module.exports = {"root":"NotificationBanners_root__2sZRh"};